import script from "./HeaderPageDefault.vue?vue&type=script&setup=true&lang=ts"
export * from "./HeaderPageDefault.vue?vue&type=script&setup=true&lang=ts"

import "./HeaderPageDefault.vue?vue&type=style&index=0&id=6dca387d&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6dca387d"]])

export default __exports__